import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import * as myGlobal from '../../../global';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/operator/do';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor( public auth: AuthService, private router: Router, private cookieService: CookieService ) {
    }

    intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
        return next.handle( request ).do( ( event: HttpEvent<any> ) => {
            if ( event instanceof HttpResponse ) {
                // do stuff with response if you want
            }
        }, ( err: any ) => {
            if ( err instanceof HttpErrorResponse ) {
                if ( ( err.status === 401 || err.status === 403 ) && err.url !== myGlobal.AUTHENTICATION + '/login' ) {
                    // redirect to the login route
                    console.log( 'Unathorized' );
                    this.cookieService.delete( 'Token' );
                    this.cookieService.delete( 'Provider' );
                    this.cookieService.delete( 'userId' );
                    this.cookieService.delete( 'username' );
                    this.cookieService.delete( 'assessment_context_id' );
                    this.router.navigate( ['login'] );
                }
            }
        } );
    }
}
